module.exports = __webpack_public_path__ + "static/full6-64109400c719f87722153791e4ac93be.png";